export default __webpack_public_path__ + "static/media/Frame.2b580b3e.svg";